import type { TemplateCard as TemplateCardData } from '@/lib/cms'

import Link from 'next/link'

import { useTranslation } from '@/i18n'

interface TemplateCardProps {
    template: TemplateCardData
    primaryTagName?: string
    /** Visually hidden (kept in the DOM so links stay crawlable for the Load more pattern). */
    hidden?: boolean
}

export function TemplateCard({ template, primaryTagName, hidden }: TemplateCardProps) {
    const { t } = useTranslation()

    return (
        <div role='listitem' className='template-item w-dyn-item' style={hidden ? { display: 'none' } : undefined}>
            <div className='template-item-new'>
                <Link href={`/t/${template.slug}`} className='template-item-link-new w-inline-block'>
                    <div className='template-item-image-wrap-new'>
                        {template.thumbnail_image ? (
                            <img
                                src={template.thumbnail_image}
                                loading='lazy'
                                alt={template.thumbnail_image_alt || template.name}
                                className='template-card-image'
                            />
                        ) : (
                            <div className='template-card-image' />
                        )}
                    </div>
                    <div className='template-item-content-new'>
                        <div className='template-item-name-new'>{template.name}</div>
                        {template.price && <div className='item-price-strike'>{template.price}</div>}
                    </div>
                </Link>
                {template.primary_tag && (
                    <div className='template-item-category'>
                        <Link href={`/tags/${template.primary_tag}`} className='primary-tag-link w-inline-block'>
                            <div className='primary-tag-holder'>
                                <div className='grey-text'>{primaryTagName ?? template.primary_tag}</div>
                            </div>
                        </Link>
                    </div>
                )}
                <a href='https://app.wedoflow.com/pricing' className='subscribe-to-download-button w-inline-block'>
                    <div>{t.home.subscribeToDownload}</div>
                    <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 24 24' fill='none' className='download-icon'>
                        <path d='M12 15L12 3M12 15L8 11M12 15L16 11' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                        <path d='M2 17L2.62127 19.4851C2.84385 20.3754 3.64382 21 4.56155 21H12H19.4384C20.3562 21 21.1561 20.3754 21.3787 19.4851L22 17' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>
                </a>
            </div>
        </div>
    )
}
